// Masquer les boutons pendant le chargement pour éviter le flash
const _vcsStyle = document.createElement('style');
_vcsStyle.id = 'vcs-loading-style';
_vcsStyle.textContent = `
  variant-selects label, variant-radios label,
  .product-form input[type="radio"] + label {
    opacity: 0 !important;
    transition: opacity 0.15s ease;
  }
`;
document.head.appendChild(_vcsStyle);

(function () {
  const colorMap = {
    'gris': '#9E9E9E',
    'orange': '#FF6600',
    'noir': '#1A1A1A'
  };

  function applyColorToSizeButtons(colorValue) {
    const color = colorValue.toLowerCase();
    const hex = colorMap[color] || null;
    document.querySelectorAll('input[type="radio"]').forEach(function (input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      const isSize = input.name.toLowerCase().includes('pointure') ||
                     input.name.toLowerCase().includes('size') ||
                     input.closest('[data-option-index="0"]') !== null;
      if (!isSize) return;
      if (input.checked && hex) {
        label.style.backgroundColor = hex;
        label.style.borderColor = hex;
        label.style.color = '#ffffff';
        label.style.border = '2px solid ' + hex;
      } else if (hex) {
        label.style.backgroundColor = '#ffffff';
        label.style.borderColor = hex;
        label.style.color = hex;
        label.style.border = '2px solid ' + hex;
      }
    });
  }

  function styleColorButtons() {
    document.querySelectorAll('input[type="radio"]').forEach(function (input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      const isColor = input.name.toLowerCase().includes('couleur') ||
                      input.name.toLowerCase().includes('color') ||
                      input.closest('[data-option-index="1"]') !== null;
      if (!isColor) return;
      const color = input.value.toLowerCase();
      const hex = colorMap[color] || '#cccccc';
      label.style.width = '40px';
      label.style.height = '40px';
      label.style.borderRadius = '50%';
      label.style.padding = '0';
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.justifyContent = 'center';
      label.style.cursor = 'pointer';
      label.style.border = '3px solid ' + hex;
      label.style.fontSize = '0';
      label.style.margin = '5px';
      if (input.checked) {
        label.style.backgroundColor = hex;
        label.style.boxShadow = '0 0 0 2px white, 0 0 0 4px ' + hex;
      } else {
        label.style.backgroundColor = hex;
        label.style.boxShadow = 'none';
      }
    });
  }

  function swapImageForColor(colorValue) {
    if (!window.productVariants) return;
    const color = colorValue.toLowerCase();
    const match = window.productVariants.find(function (v) {
      return v.options.some(function (o) { return o.toLowerCase() === color; }) && v.featured_image;
    });
    if (match && match.featured_image) {
      const mainImg = document.querySelector('.product__media img, .product-single__photo img, [data-product-featured-image]');
      if (mainImg) {
        mainImg.src = match.featured_image.src;
        mainImg.srcset = '';
      }
    }
  }

  function initStyles() {
    styleColorButtons();
    const defaultColorInput = document.querySelector('input[type="radio"]:checked[name*="ouleur"], input[type="radio"]:checked[name*="olor"]');
    if (defaultColorInput) {
      applyColorToSizeButtons(defaultColorInput.value);
      swapImageForColor(defaultColorInput.value);
    }
    const loadingStyle = document.getElementById('vcs-loading-style');
    if (loadingStyle) loadingStyle.remove();
  }

  // Exécuter dès que le DOM est prêt, sans attendre les images
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStyles);
  } else {
    initStyles();
  }

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.type !== 'radio') return;
    const isColor = input.name.toLowerCase().includes('couleur') ||
                    input.name.toLowerCase().includes('color') ||
                    input.closest('[data-option-index="1"]') !== null;
    if (isColor) {
      styleColorButtons();
      applyColorToSizeButtons(input.value);
      swapImageForColor(input.value);
    } else {
      const colorInput = document.querySelector('input[type="radio"]:checked[name*="ouleur"], input[type="radio"]:checked[name*="olor"]');
      if (colorInput) applyColorToSizeButtons(colorInput.value);
    }
  });

})();
